import { Navigate } from 'react-router-dom';
import { useParams } from '@/lib/navigation';
import CategoryView from '@/components/help-center/CategoryView';
import { GuidePageShell } from '@/components/help-center/GuidePageShell';
import { resolveGuideCategoryId } from '@/lib/guide-routes';

export default function GuideCategoryPage() {
  const { category = '' } = useParams<{ category: string }>();
  const categoryId = resolveGuideCategoryId(category);
  if (!categoryId) return <Navigate to="/" replace />;

  return (
    <GuidePageShell>
      <CategoryView category={categoryId} />
    </GuidePageShell>
  );
}
